// extracted by mini-css-extract-plugin
module.exports = {"SecondaryContainer":"ChannelVideos_SecondaryContainer__HZOgP","PrimaryContainer":"ChannelVideos_PrimaryContainer__2PaUj","NoDataAvailable":"ChannelVideos_NoDataAvailable__3297Z"};